<!-- Header -->
<div mat-dialog-title
	role="heading">
	Properties of Current Query
</div>

<!-- Body -->
<mat-dialog-content>

	<!-- Name -->
	<div class="property">
		<label>
			Name
		</label>
		<div>
			{{currentQuery.QueryName}}
		</div>
	</div>

	<!-- Scope -->
	<div class="property">
		<label>
			Scope
		</label>
		<div>
			{{currentQuery.Scope}}
		</div>
	</div>

	<!-- Owner -->
	<div class="property">
		<label>
			Owner
		</label>
		<div>
			{{currentQuery.OwnerName}}
		</div>
	</div>

	<!-- Last Updated -->
	<div class="property">
		<label>
			Last Updated
		</label>
		<div>
			{{currentQuery.UpdatedOn | date: 'MM/dd/yy'}}
		</div>
	</div>

	<!-- Description -->
	<div class="property">
		<label>
			Description
		</label>
		<div>
			{{currentQuery.Description}}
		</div>
	</div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left"></div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button image="Cancel.png"
			label="Close"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>